module.exports = __webpack_public_path__ + "static/media/asking.d528ec9d.svg";